module.exports = __webpack_public_path__ + "img/img (64).e837b1c1.jpg";